import React from 'react'
import SubscriptionsContextProvider, {
    SubscriptionsContext,
    ACTIONS
} from "../../context/SubscriptionsContextProvider";
import AltaSubscriptions from '../AltaSubscriptions'

import "../../styles/index.scss"
import { decode_utf8 } from '../../../../common/utils/utilsFunc'
import ModificationSubscriptions from '../ModificationSubscriptions'
import AnulationSubscription from '../AnulationSubscriptions'
import Loading from "../../../../common/components/Loading";

const ControllerSubscriptionsPub = (
    { props }) => {
    const [state, dispatch] = React.useContext(SubscriptionsContext);
    const [idClient, setIdClient] = React.useState('')
    const [detailClientJson, setDetailClientJson] = React.useState([])
    const [loading, setLoading] = React.useState(false);
    const [typeParam, setTypeParam] = React.useState("alta");
    const [claveParam, setClaveParam] = React.useState("");
    const TAB_URL_QUERY_STRING = "tipo";
    const SECRET_KEY_QUERY_STRING = "clave";

    React.useEffect(() => {
        const param = new URLSearchParams(window.location.search).get(TAB_URL_QUERY_STRING);
        if (param) {
            setTypeParam(param);
        }
    }, [])

    React.useEffect(() => {
        const param = new URLSearchParams(window.location.search).get(SECRET_KEY_QUERY_STRING);
        if (param) {
            setClaveParam(param);
        }
    }, [])

    React.useEffect(() => {
        if (idClient) {
            setLoading(true)
            dispatch({
                type: ACTIONS.SET_IDCLIENT,
                payload: idClient
            })
            setIdClient("")
        }
    }, [idClient])

    React.useEffect(() => {
        if (state.detailClient) {
            setLoading(false)
            if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
                if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
                    setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
                } else {
                    setDetailClientJson([]);
                    props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
                }
            } else {
                setDetailClientJson([]);
                props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
            }
        }
    }, [state.detailClient])

    function handleClickTab(type) {
        let searchParams = new URLSearchParams(window.location.search);
        searchParams.set(TAB_URL_QUERY_STRING, type);
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.pushState({ path: newurl }, '', newurl);
        setTypeParam(type);
    }

    return (
        <div className="container-table">
            <nav>
                <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
                    <li className="nav-item">
                        <a onClick={() => handleClickTab("alta")} className={`nav-link ${typeParam === "alta" && "active"} pb-2`} id="alta-subscription" data-toggle="tab" href="#altaSubscription" role="tab" aria-controls="altaSubscription" aria-selected="true" data-lineheight="30" data-fontsize="18" >{decode_utf8(props.title_alta_subscription)}</a>
                    </li>

                    <li className="nav-item">
                        <a onClick={() => handleClickTab("modificar")} className={`nav-link ${typeParam === "modificar" && "active"} pb-2`} id="modification-subscription" data-toggle="tab" href="#modificationSubscription" role="tab" aria-controls="modificationSubscription" aria-selected="false" data-lineheight="30" data-fontsize="18" >{decode_utf8(props.title_modification_subscription)}</a>
                    </li>

                    <li className="nav-item">
                        <a onClick={() => handleClickTab("anular")} className={`nav-link ${typeParam === "anular" && "active"} pb-2`} id="anulation-subscription" data-toggle="tab" href="#anulationSubscription" role="tab" aria-controls="anulationSubscription" aria-selected="false" data-lineheight="30" data-fontsize="18" >{decode_utf8(props.title_anulation_subscription)}</a>
                    </li>
                </ul>
            </nav>
            <div className="tab-content" id="myTabContent">
                <div className={`tab-pane fade show ${typeParam === "alta" && "active show"}`} id="altaSubscription" role="tabpanel" aria-labelledby="alta-subscription">
                    <AltaSubscriptions
                        props={{ ...props, state, idClient, setIdClient, detailClientJson, setDetailClientJson, claveParam, setClaveParam }}
                    /></div>
                <div class={`tab-pane fade ${typeParam === "modificar" && "active show"}`} id="modificationSubscription" role="tabpanel" aria-labelledby="modification-subscription">
                    <ModificationSubscriptions
                        props={{ ...props, state, idClient, setIdClient, detailClientJson, setDetailClientJson, claveParam, setClaveParam }} />
                </div>
                <div class={`tab-pane fade ${typeParam === "anular" && "active show"}`} id="anulationSubscription" role="tabpanel" aria-labelledby="anulation-subscription">
                    <AnulationSubscription
                        props={{ ...props, state, idClient, setIdClient, detailClientJson, setDetailClientJson, claveParam, setClaveParam }} />
                </div>
            </div>
            {loading && <Loading />}
        </div>

    )
}

const ControllerSubscriptionsPubWithProvider = ({ props }) => (
    <SubscriptionsContextProvider>
        <ControllerSubscriptionsPub props={props} />
    </SubscriptionsContextProvider>
);
export default ControllerSubscriptionsPubWithProvider